import { Component, Inject, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { SliderModelService } from '../../../services/infrastructure/sliderModel.service';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';

@Component({
  selector: 'app-global-subscripton-dialog',
  templateUrl: './global-subscripton-dialog.component.html',
  styleUrls: ['./global-subscripton-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GlobalSubscriptionDialogComponent implements OnDestroy {
  private subscription = new Array<Subscription>();

  hasChangeAdded = false;
  dialogType: string;
  isSaveEnabled = false;
  isCPPConfirmation = false;
  subscriptionList: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<GlobalSubscriptionDialogComponent>,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    public matDialog: MatDialog,
    public sliderModelService: SliderModelService,

    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.dialogType = this.data.dialogType;
    if (this.data.subscriptionList != null && this.data.subscriptionList.subscriptionList != null) {
      this.subscriptionList = this.data.subscriptionList.subscriptionList;
      for (let i = 0; i <= this.data.subscriptionList.subscriptionList.length - 1; i++) {
        if (this.data.subscriptionList.isFavouriteChecked) {
          this.data.subscriptionList.subscriptionList[i].isDisabled = true;
        } else {
          this.data.subscriptionList.subscriptionList[i].isDisabled = false;
        }

        this.data.subscriptionList.subscriptionList[i].subscriptionSuplementId =
          this.data.subscriptionList.subscriptionList[i].subscriptionSuplementId?.toString();
        //if (data.subscriptionList.subscriptionList[i].subscriptionTypeID === 4 && data.subscriptionList.subscriptionList[i].isStopLightChecked) {
        //  this.data.subscriptionList.subscriptionList[i].addOnSubscription = 'Order Stoplight';
        //}
        //if (!this.data.subscriptionList.subscriptionList[i].hasOwnProperty('addOnSubscription')) {
        //  this.data.subscriptionList.subscriptionList[i].isStopLightChecked = false;
        //}
        
        this.data.subscriptionList.subscriptionList[i].isServerSideChecked = this.data.subscriptionList.subscriptionList[i].isChecked;
      }
    } else if (this.data.subscriptionList != null) {
      this.subscriptionList = this.data.subscriptionList;
      for (let i = 0; i <= this.data.subscriptionList.length - 1; i++) {
        if (this.data.subscriptionList.isFavouriteChecked) {
          this.data.subscriptionList[i].isDisabled = true;
        } else {
          this.data.subscriptionList[i].isDisabled = false;
        }
        this.data.subscriptionList[i].isServerSideChecked = this.data.subscriptionList[i].isChecked;
        this.data.subscriptionList[i].subscriptionSuplementId = this.data.subscriptionList[i].subscriptionSuplementId?.toString();
        //if (data.subscriptionList[i].subscriptionTypeID === 4 && data.subscriptionList[i].isStopLightChecked) {
        //  this.data.subscriptionList[i].addOnSubscription = 'Order Stoplight';
        //}
        //this.data.subscriptionList[i].addOnSubscription
       // this.data.subscriptionList[i].addOnSubscription = this.data.subscriptionList[i].addOnSubscription;
      }
    }
  }
  ngOnInit(): void {
    this.subscriptionList.forEach(sub => {
      if (sub.subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION' && sub.isStopLightChecked ) {
        sub.addOnSubscription = 'Order Stoplight';
      }
    });
  }
  onNoClick(): void {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back', dialogType: 'confirm' }
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
          closebutton.style.display = '';
          this.sliderModelService.close();
          this.dialogRef.close();
        }
      }));
    }
    else {
      const closebutton = document.getElementsByClassName('close-btn')[0] as HTMLElement;
      closebutton.style.display = '';
      this.sliderModelService.close();
      this.dialogRef.close();
    }
  }

  onCheckboxChange(status: boolean, element: any) {
    element.isServerSideChecked = status;
    if (element.isServerSideChecked && element.subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION' && element.addOnSubscription == 'Order Stoplight') {
      element.isStopLightChecked = true;
    }
    else {
      element.isStopLightChecked = false;
    }
    this.hasChangeAdded = true;
    this.isSaveEnabled = true;
  }
  onSubscriptionChange(selectedValue: string, element: any) {
    element.addOnSubscription = selectedValue;

    if (element.subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION') {
      if (selectedValue === 'Order Stoplight') {
        element.isStopLightChecked = true;
      } else {
        element.isStopLightChecked = false;
      }
    }
    this.isSaveEnabled = true;
  }
  onGlobalSubscriptionChange(selectedValue: string, element: any) {
    element.addOnSubscription = selectedValue;
    if (element.subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION') {
      if (selectedValue === 'Order Stoplight') {
        element.isStopLightChecked = true;
      } else {
        element.isStopLightChecked = false;
      }
    }
    this.isSaveEnabled = true;
  }

  onSupplementChange() {
    this.isSaveEnabled = true;
  }

  onFavouriteCheckboxChange($event) {
    this.data.subscriptionList.isFavouriteChecked = $event.checked;
    for (let i = 0; i <= this.data.subscriptionList.subscriptionList.length - 1; i++) {
      if ($event.checked === true) {
        this.data.subscriptionList.subscriptionList[i].isDisabled = true;
        this.data.subscriptionList.subscriptionList[i].isServerSideChecked = true;
        if (this.data.subscriptionList.subscriptionList[i].subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION') {
          this.data.subscriptionList.subscriptionList[i].isStopLightChecked = true;
          this.data.subscriptionList.subscriptionList[i].addOnSubscription = 'Order Stoplight';
        }
      } else {
        this.data.subscriptionList.subscriptionList[i].isServerSideChecked = this.data.subscriptionList.subscriptionList[i].isChecked;
        this.data.subscriptionList.subscriptionList[i].isStopLightChecked = this.data.subscriptionList.subscriptionList[i].isStopLightChecked;
        this.data.subscriptionList.subscriptionList[i].isDisabled = false;
      }
    }
    this.hasChangeAdded = true;
    this.isSaveEnabled = true;
  }

  onGlobalFavouriteCheckboxChange($event) {
    for (let i = 0; i <= this.data.subscriptionList.length - 1; i++) {
      this.data.subscriptionList[0].isFavouriteChecked = $event.checked;
      if ($event.checked === true) {
        this.data.subscriptionList[i].isServerSideChecked = true;
        this.data.subscriptionList[i].isDisabled = true;
        if (this.data.subscriptionList[i].subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION') {
          this.data.subscriptionList[i].isStopLightChecked = true;
          this.data.subscriptionList[i].addOnSubscription = 'Order Stoplight';
        }
      } else {
        this.data.subscriptionList[i].isServerSideChecked = this.data.subscriptionList[i].isChecked;
        this.data.subscriptionList[i].isDisabled = false;
        this.data.subscriptionList[i].isStopLightChecked = this.data.subscriptionList[i].isStopLightChecked;
      }
    }
    this.hasChangeAdded = true;
    this.isSaveEnabled = true;
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}

export interface DialogData {
  subscriptionList: any;
  dialogType: string;
  selectedIndex: number;
  isFavouriteOptionAvailable: boolean;
  isFavouriteChecked: boolean;
  isStopLightChecked: boolean
}
